import gateway from '@/gateway'

const defaultTile = {
  title: '',
  body: null,
  file: '',
  cover: '',
}
const defaultIndexState = {
  title: '',
  slug: '',
  draft: {
    title: '',
    channel: null,
    analysts: [],
    tags: [],
    tiles: [defaultTile],
    relatedIndices: [],
  },
}

// initial state
const state = {
  searchIndices: [],
  pageIndices: [],
  pagination: null,
  currentIndex: defaultIndexState,
}

const getters = {
  indices: (state) => state.searchIndices,
  pageIndices: (state) => state.pageIndices,
  pagination: (state) => state.pagination,
  currentIndex: (state) => state.currentIndex,
}

// actions
const actions = {
  async getSearchIndices({ commit }, params) {
    const { data } = await gateway.get(`cms/engage/indices`, {params: {...params, per_page: 1000}})
    commit('setSearchIndices', data.data)
  },
  async getPaginatedIndices({ commit }, params) {
    const indicesResponse = await gateway.get(`cms/engage/indices`, {params})

    commit('setPageIndices', indicesResponse.data)
  },
  async getCurrentIndex({ commit }, {slug}) {
    const indexResponse = await gateway.get(`cms/engage/indices/${slug}`)
    const currentIndex = indexResponse.data.data
    const presentArray = (arr, defaultValue: any[] = []) => {
      if (!arr) return defaultValue
      if (!arr.length) return defaultValue
      return arr
    }
    currentIndex.draft = {
      ...currentIndex.draft,
      analysts: presentArray(currentIndex.draft.analysts),
      tiles: presentArray(currentIndex.draft.tiles, [defaultTile]),
      tags: presentArray(currentIndex.draft.tags),
      relatedIndices: presentArray(currentIndex.draft.relatedIndices),
    }

    commit('setCurrentIndex', currentIndex)
  },
  resetCurrentIndex({commit}) {
    commit('setCurrentIndex', defaultIndexState)
  },
}

// mutations
const mutations = {
  setSearchIndices (state, indices) {
    state.searchIndices = indices
  },
  setPageIndices (state, response) {
    state.pageIndices = response.data
    state.pagination = response.meta
  },
  setCurrentIndex (state, index) {
    state.currentIndex = index
  },
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
